import { WidgetTranslationDto } from '@/Domain/api/WIdget/dto/WidgetTranslation.dto';

export const emptyTranslation = (language: string, country: string): WidgetTranslationDto => ({
  language,
  country,
  welcome_message: '',
  welcome_message2: '',
  header: '',
  subtitle: '',
  input_placeholder: '',
  conversation_starters: [],
  prechat_header_text: '',
  prechat_button_text: '',
  prechat_message_text: '',
  background_disclaimer_text: '',
  launcher_label: '',
});

export const toFormValues = (
  row: WidgetTranslationDto | undefined,
  language: string,
  country: string,
): WidgetTranslationDto => {
  const base = emptyTranslation(language, country);
  if (!row) return base;
  return {
    ...base,
    welcome_message: row.welcome_message ?? '',
    // welcome_message2 / subtitle have no editor field, but the autosave PUT is a
    // full-row upsert — carry through any API-set value so an unrelated edit can't
    // null it out.
    welcome_message2: row.welcome_message2 ?? '',
    header: row.header ?? '',
    subtitle: row.subtitle ?? '',
    input_placeholder: row.input_placeholder ?? '',
    conversation_starters: row.conversation_starters ?? [],
    prechat_header_text: row.prechat_header_text ?? '',
    prechat_button_text: row.prechat_button_text ?? '',
    prechat_message_text: row.prechat_message_text ?? '',
    background_disclaimer_text: row.background_disclaimer_text ?? '',
    launcher_label: row.launcher_label ?? '',
  };
};
